module.exports = __webpack_public_path__ + "../images/logo_trade/metamask_cb.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo_trade/metamask_cb.png
// module id = 664
// module chunks = 0